"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-1e44356a"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "aside-layout" };
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var index_1 = require("@/store/index");
var SubMenu_vue_1 = __importDefault(require("./SubMenu.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AsideComponent',
    setup: function (__props) {
        /* eslint-disable */
        var mainStore = (0, index_1.useMainStore)();
        var router = (0, vue_router_1.useRouter)();
        var route = (0, vue_router_1.useRoute)();
        var menuList = (0, vue_3.ref)(router.options.routes[0].children);
        // const formatRouter = (arr: any) => {
        //   arr.forEach((element: any) => {
        //     if (element.children && element.children.length > 0) {
        //       formatRouter(element.children)
        //     }
        //     console.log(element);
        //     if(!element.hidden){
        //     }
        //   });
        // }
        // formatRouter(router.options.routes[0].children)
        return function (_ctx, _cache) {
            var _component_el_menu = (0, vue_2.resolveComponent)("el-menu");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_el_menu, {
                    style: { "overflow-x": "hidden" },
                    "collapse-transition": false,
                    "unique-opened": true,
                    collapse: (0, vue_2.unref)(mainStore).isCollapse,
                    class: "el-menu-vertical-demo scroll-bar",
                    "default-active": (0, vue_2.unref)(route).path,
                    router: true
                }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(menuList.value, function (item) {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SubMenu_vue_1.default, {
                                key: item.name,
                                item: item
                            }, null, 8, ["item"]));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["collapse", "default-active"])
            ]));
        };
    }
});
